import {OptionMap} from "../../../helpers/optionMap";
import ConditionalFormSection, {ConditionalFormSectionMap} from "../../formItems/ConditionalFormSection";
import {GenerateInvoiceFormValues} from "./types";
import React from "react";
import {Input, InputNumber, Select} from "antd";
import {formItemFactory} from "../../formItems/FormItemFactory";
import validations from "./validations";
import { InvoiceDiscountType } from "./discount";

export const GenerateInvoiceFormItem = formItemFactory<GenerateInvoiceFormValues>(
  validations
);
const ContractReferenceInput = () => (
  <GenerateInvoiceFormItem name="contractReference" label="Contract Reference">
    <Input placeholder="Enter contract reference" />
  </GenerateInvoiceFormItem>
);

export const invoiceExtraFieldsMap: ConditionalFormSectionMap<
  GenerateInvoiceFormValues,
  "invoiceType"
> = new Map([
  [
    [
      "INVOICE_EPI",
      "ACT_EPI",
      "ACT_EPI_BYN",
      "INVOICE_WARRANTY",
      "ACT_WARRANTY_BYN",
      "ACT_WARRANTY",
      "REREGISTRATION_EPI",
      "REREGISTRATION_CERTIFICATE",
      "ACT_WARRANTY_T1_BYN",
      "ACT_WARRANTY_T1",
      "INVOICE_T1",
    ],
    <ContractReferenceInput />,
  ],
]);

// Specification title with pre-filled values block
export const specificationTitleObject = {
  'specification': 'Specifikacja',
  'faktura': 'FAKTURA (INVOICE)',
  'other': 'Custom',
} as const;
export const specificationInvoiceSelectOptions = new OptionMap(specificationTitleObject);
export type InvoiceSpecificationTitle = keyof typeof specificationTitleObject;

const SpecificationInvoiceTitleSelect = () => (
  <GenerateInvoiceFormItem name={"prefilledTitle"} label={"Title"}>
    <Select
      placeholder={"Select Title"}
      options={specificationInvoiceSelectOptions.getSelectOptions()}
    />
  </GenerateInvoiceFormItem>
);

const SpecificationInvoiceTitleInput = () => (
  <GenerateInvoiceFormItem name={"title"} label={"Custom Title"}>
    <Input placeholder={"Enter Title"} />
  </GenerateInvoiceFormItem>
);

export const invoiceTitleFieldsMap: ConditionalFormSectionMap<
  GenerateInvoiceFormValues,
  "invoiceType"
> = new Map([
  [
    ["SPECIFICATION", "SPECIFICATION_T1"],
    <SpecificationInvoiceTitleSelect />,
  ],
]);

export const invoiceCustomTitleFieldMap: ConditionalFormSectionMap<GenerateInvoiceFormValues, "prefilledTitle"> = new Map([
  [
    ["other"],
    <SpecificationInvoiceTitleInput />
  ],
]);

const SpecificationDiscountValueInput = ({ label, disabled = false }: {
  label: string;
  disabled?: boolean;
}) => (
  <GenerateInvoiceFormItem
    name="discountValue"
    label={label}
    preserve={false}
    dependencies={["discountType"]}
  >
    <InputNumber
      disabled={disabled}
      step={0.01}
      style={{ width: "100%" }}
      placeholder="Optional"
    />
  </GenerateInvoiceFormItem>
);

const discountValueFieldsMap: ConditionalFormSectionMap<
  GenerateInvoiceFormValues,
  "discountType"
> = new Map<
  GenerateInvoiceFormValues["discountType"] | GenerateInvoiceFormValues["discountType"][],
  React.ReactNode
>([
  ["percentage", <SpecificationDiscountValueInput label="Discount (%)" />],
  ["fixed", <SpecificationDiscountValueInput label="Discount (EUR)" />],
  [[null, undefined], <SpecificationDiscountValueInput label="Discount Value" disabled />],
]);

const SpecificationDiscountFields = () => (
  <>
    <GenerateInvoiceFormItem name="discountType" label="Discount Type" preserve={false}>
      <Select<InvoiceDiscountType>
        allowClear
        placeholder="No discount"
        options={[
          { value: "percentage", label: "Percentage (%)" },
          { value: "fixed", label: "Fixed Amount (EUR)" },
        ]}
      />
    </GenerateInvoiceFormItem>
    <ConditionalFormSection field="discountType" map={discountValueFieldsMap} />
  </>
);

export const invoiceDiscountFieldsMap: ConditionalFormSectionMap<
  GenerateInvoiceFormValues,
  "invoiceType"
> = new Map([
  [["SPECIFICATION", "SPECIFICATION_T1"], <SpecificationDiscountFields />],
]);